import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../core/utils';
import { selectPrimaryCalculatorPaymentOptions } from '../../../core/reducers/financialCalculators';
import getColorSwatchWithUpCharge from '../utils/getColorSwatchWithUpCharge';
import { paymentOptionLabelMap } from '../utils/constants';
export const ColorType = {
    EXT: 'exterior',
    INT: 'interior',
};
const tooltipLabelMap = {
    [ColorType.EXT]: 'Shared.Common.extColourUpchargeTooltipLabel',
    [ColorType.INT]: 'Shared.Common.intColourUpchargeTooltipLabel',
};
const useColorSwatchWithUpCharge = ({ colors, colorsUpCharge, colorType }) => {
    const { t } = useTranslation();
    const { paymentFrequency } = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const paymentFrequencyLabel = t(paymentOptionLabelMap[paymentFrequency]);
    const tooltipLabel = t(tooltipLabelMap[colorType]);
    return getColorSwatchWithUpCharge({
        colors,
        colorsUpCharge,
        paymentFrequency: paymentFrequencyLabel,
        tooltipLabel,
    });
};
export default useColorSwatchWithUpCharge;
